import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonWalking, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import NavigationButtons from './NavigationButtons';
import './NavigationButtons.css';
import './RouteDetails.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const RouteDetailsWalk = ({ 
  from, 
  to, 
  selectedRoute, 
  setShowWalkOverlay, 
  setShowMapOverlay, 
  setSelectedRoute 
}) => {
  return (
    <div className="route-details-overlay">
      <div className="route-details-header">
        <div className="route-details-title">
          🚶 Walk from {from} to {to}
        </div>
        <button onClick={() => setShowWalkOverlay(false)} className="route-details-close-button">
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>

      {selectedRoute && (
        <div className="route-details-summary-card">
          <div className="route-details-journey-title">
            Route Summary
          </div>

          <div className="route-details-duration-distance">
            ⏱ <strong>{selectedRoute.duration}</strong> &nbsp; • &nbsp; 📏 {selectedRoute.distance}
          </div>

          <div className="route-details-price">
            🧾 Fare: <strong>{selectedRoute.fare}</strong>
          </div>

          <div className="route-details-note">
            Walking is free, healthy, and eco-friendly. Stay hydrated!
          </div>
        </div>
      )}

      <NavigationButtons
        from={from}
        to={to}
        setSelectedRoute={setSelectedRoute}
        selectedRoute={selectedRoute}
        travelMode="walking"
      />
    </div>
  );
};

export default RouteDetailsWalk; 